export enum OwnerEnum {
    Event = 1,
    Group = 2,
    Project = 3,
    Product = 4,
    Service = 5,
    User = 6
}